
import CanvasJSReact_ReportMonthly from '../chart/Chart_ReportMonthly';

import {
    getErrText,
    getErrColor,
    createdata_row
} from "./library"

import './bee-print-monthly.css';

function SiteReportMonthly({ reportdata, reportchart }) {
    return (
        <div className='report-wrapper'>
            <div className="page-horizontal rp-monthly">
                <div className="document-header">
                    <div className="document-logo-left">
                        <img src="/images/ReportLogoleft.bmp" className="logo" style={{ opacity: "1" }} alt='logo-left1' />
                    </div>
                    <div className="document-logo-right">
                        {/* <img src="/images/ReportLogoright.bmp" className="logo" style={{ opacity: "1" }} alt='logo-right1' /> */}
                        <div className="company-box">
                            SHINING SPV 1 CO., LTD.
                        </div>
                    </div>

                    <label className="document-type">Monthly Report</label>
                    <label className="document-date" id="data-monthly-header-reportdate1">{reportdata.Header?.ReportDate}</label>
                    <label className="document-sitelocation" id="data-monthly-header-sitename1">{reportdata.Header?.SiteName}</label>
                    <label className="document-pages">Pages 1/3</label>

                    <div className="document-capacity">
                        <div className="container">
                            <label>Capacity</label>
                            <span className='font-sarabun' id="data-monthly-header-capacity1">{reportdata.Header?.Capacity}</span>
                            <span className="totalunit">kWp</span>
                        </div>
                    </div>

                    <div className="document-area">
                        <div className="container">
                            <label>Area</label>
                            <span className='font-sarabun' id="data-monthly-header-area1">{reportdata.Header?.Area}</span>
                            <span className="totalunit">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                <div className="document-info">
                    <div className="document-info1">
                        <div className="container">
                            <label>Energy from Solar {reportdata.Header?.SolarType}</label>
                            <span className='font-sarabun' id="data-monthly-info-energysolar1">{reportdata.Info?.EnergySolar}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, On-Peak</label>
                            <span className='font-sarabun ' id="data-monthly-info-energysolar-onpeak1">{reportdata.Info?.EnergySolar_OnPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, Off-Peak</label>
                            <span className='font-sarabun ' id="data-monthly-info-energysolar-offpeak1">{reportdata.Info?.EnergySolar_OffPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                    </div>

                    <div className="document-info2">
                        <div className="container">
                            <label>Energy not Supply (ENS)</label>
                            <span className='font-sarabun' id="data-monthly-info-ens1" >{reportdata.Info?.ENS}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>CO<sub>2</sub> Reduction</label>
                            <span className='font-sarabun' id="data-monthly-info-co21">{reportdata.Info?.CO2}</span>
                            <span className="totalunit">kgCO<sub>2</sub></span>
                        </div>
                    </div>

                    <div className="document-info3">
                        <div className="container">
                            <label>PR</label>
                            <span id="data-monthly-info-prens1" className={'font-sarabun ' + getErrColor(reportdata.FlagPR)}>{getErrText(reportdata.FlagPR, reportdata.Info?.PR_ENS)}</span>
                            <span className="totalunit">%</span>
                        </div>
                        <div className="container">
                            <label>OR</label>
                            <span id="data-monthly-info-or1" className={'font-sarabun ' + getErrColor(reportdata.FlagOR)}>{reportdata.Info?.ORX_ENS}</span>
                            <span className="totalunit">%</span>
                        </div>
                    </div>

                    <div className="document-info4">
                        <div className="container">
                            <label>Irradiance</label>
                            <span className='font-sarabun' id="data-monthly-info-irr1">{reportdata.Info?.IRR}</span>
                            <span className="totalunit">Wh/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Irradiance (max)</label>
                            <span className='font-sarabun' id="data-monthly-info-irrmax1">{reportdata.Info?.IRRMax}</span>
                            <span className="totalunit">W/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Module Temp (max)</label>
                            <span className='font-sarabun' id="data-monthly-info-tempmax1">{reportdata.Info?.ModuleTempMax}</span>
                            <span className="totalunit">°C</span>
                        </div>
                    </div>
                </div>



                <div className="itemtable">
                    <table className="tablex table-hover table-monthly" id="table-monthly-report1">
                        <thead className="table-header">
                            <tr className="r1">
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2" id="cDateM">Date</th>
                                <th className="horizinton-align-center bottom-black-line" colSpan="2">
                                    Irradiance</th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">A. Temp. <p>(°C)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">M. Temp. <p>(°C)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Est. Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Solar Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Diff. Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">ENS <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">CO<sub>2</sub> Reduction <p>
                                    (kgCO<sub>2</sub>)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">PR <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">OR <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Solar <p>Avai (%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Energy Grid <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Est. Value <p>(Baht)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Est. Saving <p>(Baht)</p>
                                </th>
                            </tr>
                            <tr className="r2">
                                <th className="horizinton-align-center bottom-black-line">
                                    (Wh/m<sup>2</sup>)</th>
                                <th className="horizinton-align-center bottom-black-line">
                                    (Wmax/m<sup>2</sup>)</th>
                            </tr>
                        </thead>
                        <tbody >
                            {
                                reportdata.TableData?.map((data, index) => (
                                    index < 20 ?
                                        <tr key={"data-monthly-D" + data.DateNo} className={data.IsSunday === true ? "sundaymark" : ""}>
                                            <td align="center" className="item col-rx-black">{data.Datex}</td>
                                            {createdata_row(data.FlagIRR, data.IRR, data.CODStatus)}
                                            {createdata_row(data.FlagIRR, data.IRRMax, data.CODStatus)}
                                            {createdata_row(data.FlagTempAmbient, data.AmbientTemp, data.CODStatus)}
                                            {createdata_row(data.FlagTempModule, data.ModuleTemp, data.CODStatus)}
                                            {createdata_row(data.FlagEstEnergy, data.EST_Energy, data.CODStatus)}
                                            {createdata_row(data.FlagSolar, data.EnergyAC, data.CODStatus)}
                                            {createdata_row("", data.Diff_Energy, data.CODStatus)}
                                            {createdata_row(data.FlagENS, data.ENS, data.CODStatus)}
                                            {createdata_row("", data.CO2, data.CODStatus)}
                                            {createdata_row(data.FlagPR, data.PR_ENS, data.CODStatus)}
                                            {createdata_row(data.FlagOR, data.ORX_ENS, data.CODStatus)}
                                            {createdata_row("", data.AVI, data.CODStatus)}
                                            {createdata_row(data.FlagGrid, data.EnergyGrid, data.CODStatus)}
                                            {createdata_row("", data.EST_Value, data.CODStatus)}
                                            {createdata_row("", data.EST_Saving, data.CODStatus)}
                                        </tr>
                                        :
                                        null
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                <div className="doc-remark">
                    <label className="generate-remark1" id="generate-daily-print1">Printed Date : {reportdata.Header?.PrintDate}</label>
                    <label className="generate-remark2">* This reports have been generated by CPF solar monitoring system local web
                        application. *</label>
                </div>
            </div>

            <div className="page-horizontal rp-monthly mt-2">
                <div className="document-header">
                    <div className="document-logo-left">
                        <img src="/images/ReportLogoleft.bmp" className="logo" style={{ opacity: "1" }} alt='logo-left2' />
                    </div>
                    <div className="document-logo-right">
                        {/* <img src="/images/ReportLogoright.bmp" className="logo" style={{ opacity: "1" }} alt='logo-right2' /> */}
                        <div className="company-box">
                            SHINING SPV 1 CO., LTD.
                        </div>
                    </div>

                    <label className="document-type">Monthly Report</label>
                    <label className="document-date" id="data-monthly-header-reportdate2">{reportdata.Header?.ReportDate}</label>
                    <label className="document-sitelocation" id="data-monthly-header-sitename2">{reportdata.Header?.SiteName}</label>
                    <label className="document-pages">Pages 2/3</label>

                    <div className="document-capacity">
                        <div className="container">
                            <label>Capacity</label>
                            <span className='font-sarabun' id="data-monthly-header-capacity2">{reportdata.Header?.Capacity}</span>
                            <span className="totalunit">kWp</span>
                        </div>
                    </div>

                    <div className="document-area">
                        <div className="container">
                            <label>Area</label>
                            <span className='font-sarabun' id="data-monthly-header-area2">{reportdata.Header?.Area}</span>
                            <span className="totalunit">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>


                <div className="document-info">
                    <div className="document-info1">
                        <div className="container">
                            <label>Energy from Solar {reportdata.Header?.SolarType}</label>
                            <span className='font-sarabun' id="data-monthly-info-energysolar2">{reportdata.Info?.EnergySolar}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, On-Peak</label>
                            <span className='font-sarabun ' id="data-monthly-info-energysolar-onpeak2">{reportdata.Info?.EnergySolar_OnPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, Off-Peak</label>
                            <span className='font-sarabun ' id="data-monthly-info-energysolar-offpeak2">{reportdata.Info?.EnergySolar_OffPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                    </div>
                    <div className="document-info2">
                        <div className="container">
                            <label>Energy not Supply (ENS)</label>
                            <span className='font-sarabun' id="data-monthly-info-ens2" >{reportdata.Info?.ENS}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>CO<sub>2</sub> Reduction</label>
                            <span className='font-sarabun' id="data-monthly-info-co22">{reportdata.Info?.CO2}</span>
                            <span className="totalunit">kgCO<sub>2</sub></span>
                        </div>
                    </div>
                    <div className="document-info3">
                        <div className="container">
                            <label>PR</label>
                            <span id="data-monthly-info-prens2" className={'font-sarabun ' + getErrColor(reportdata.FlagPR)}>{getErrText(reportdata.FlagPR, reportdata.Info?.PR_ENS)}</span>
                            <span className="totalunit">%</span>
                        </div>
                        <div className="container">
                            <label>OR</label>
                            <span id="data-monthly-info-or2" className={'font-sarabun ' + getErrColor(reportdata.FlagOR)}>{reportdata.Info?.ORX_ENS}</span>
                            <span className="totalunit">%</span>
                        </div>
                    </div>

                    <div className="document-info4">
                        <div className="container">
                            <label>Irradiance</label>
                            <span className='font-sarabun' id="data-monthly-info-irr2">{reportdata.Info?.IRR}</span>
                            <span className="totalunit">Wh/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Irradiance (max)</label>
                            <span className='font-sarabun' id="data-monthly-info-irrmax2">{reportdata.Info?.IRRMax}</span>
                            <span className="totalunit">W/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Module Temp (max)</label>
                            <span className='font-sarabun' id="data-monthly-info-tempmax2">{reportdata.Info?.ModuleTempMax}</span>
                            <span className="totalunit">°C</span>
                        </div>
                    </div>
                </div>

                <div className="itemtable">
                    <table className="tablex table-hover table-monthly" id="table-monthly-report2">
                        <thead className="table-header">
                            <tr className="r1">
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2" id="cDateM">Date</th>
                                <th className="horizinton-align-center bottom-black-line" colSpan="2">
                                    Irradiance</th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">A. Temp. <p>(°C)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">M. Temp. <p>(°C)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Est. Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Solar Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Diff. Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">ENS <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">CO<sub>2</sub> Reduction <p>
                                    (kgCO<sub>2</sub>)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">PR <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">OR <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Solar <p>Avai (%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Energy Grid <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Est. Value <p>(Baht)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line" rowSpan="2">Est. Saving <p>(Baht)</p>
                                </th>
                            </tr>
                            <tr className="r2">
                                <th className="horizinton-align-center bottom-black-line">
                                    (Wh/m<sup>2</sup>)</th>
                                <th className="horizinton-align-center bottom-black-line">
                                    (Wmax/m<sup>2</sup>)</th>
                            </tr>
                        </thead>
                        <tbody >
                            {
                                reportdata.TableData?.map((data, index) => (
                                    index >= 20 ?
                                        <tr key={"data-monthly-D" + index} className={data.IsSunday === true ? "sundaymark" : ""}>
                                            <td align="center" className="item col-rx-black">{data.Datex}</td>
                                            {createdata_row(data.FlagIRR, data.IRR, data.CODStatus)}
                                            {createdata_row(data.FlagIRR, data.IRRMax, data.CODStatus)}
                                            {createdata_row(data.FlagTempAmbient, data.AmbientTemp, data.CODStatus)}
                                            {createdata_row(data.FlagTempModule, data.ModuleTemp, data.CODStatus)}
                                            {createdata_row(data.FlagEstEnergy, data.EST_Energy, data.CODStatus)}
                                            {createdata_row(data.FlagSolar, data.EnergyAC, data.CODStatus)}
                                            {createdata_row("", data.Diff_Energy, data.CODStatus)}
                                            {createdata_row(data.FlagENS, data.ENS, data.CODStatus)}
                                            {createdata_row("", data.CO2, data.CODStatus)}
                                            {createdata_row(data.FlagPR, data.PR_ENS, data.CODStatus)}
                                            {createdata_row(data.FlagOR, data.ORX_ENS, data.CODStatus)}
                                            {createdata_row("", data.AVI, data.CODStatus)}
                                            {createdata_row(data.FlagGrid, data.EnergyGrid, data.CODStatus)}
                                            {createdata_row("", data.EST_Value, data.CODStatus)}
                                            {createdata_row("", data.EST_Saving, data.CODStatus)}
                                        </tr>
                                        :
                                        null
                                ))
                            }
                            <tr className="summary" >
                                <td align="center" className="item col-rx-black">Total</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.IRR}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.IRRMax}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.AmbientTemp}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.ModuleTemp}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.EST_Energy}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.EnergyACErrDeduct}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.Diff_Energy}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.ENS}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className={"item " + getErrColor(reportdata.FlagPR)}>{getErrText(reportdata.FlagPR, reportdata.Summary?.PR_ENS)}</td>
                                <td align="right" className={"item " + getErrColor(reportdata.FlagOR)}>{reportdata.Summary?.ORX_ENS}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.AVI}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.EnergyGrid}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                            </tr>
                            <tr className="summary1" id="data-monthly-summary2">
                                <td align="center" className="item col-rx-black">Summary</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.EnergyAC}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.CO2}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.EST_Value}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.EST_Saving}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <label className="refference-remark">Remark</label>
                <div className="refference-remark1">
                    <div className="container">
                        <label>PR<sub>G</sub></label>
                        <span className='font-sarabun' id="data-monthly-ref-prg">{reportdata.Refference?.PRG}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>OR<sub>G</sub></label>
                        <span className='font-sarabun' id="data-monthly-ref-org">{reportdata.Refference?.ORG}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>@#Yr.</label>
                        <span className='font-sarabun' id="data-monthly-ref-year">{reportdata.Refference?.YR}</span>
                        <span className="totalunit"></span>
                    </div>
                </div>

                <div className="refference-remark2">
                    <div className="container">
                        <label>STC </label>
                        <span className='font-sarabun' id="data-monthly-ref-stc">{reportdata.Refference?.STC}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>1kWh = </label>
                        <span className='font-sarabun' id="data-monthly-ref-co2">{reportdata.Refference?.Factor_CO2}</span>
                        <span className="totalunit">kgCO<sub>2</sub></span>
                    </div>
                    <div className="container">
                        <label>Unit Rate, On-Peak</label>
                        <span className='font-sarabun' id="data-monthly-ref-unitrate-onpeak2">{reportdata.Refference?.Factor_UnitRate_OnPeak}</span>
                        <span className="totalunit">Baht/kWh</span>
                    </div>
                    <div className="container">
                        <label>Unit Rate, Off-Peak</label>
                        <span className='font-sarabun' id="data-monthly-ref-unitrate-offpeak2">{reportdata.Refference?.Factor_UnitRate_OffPeak}</span>
                        <span className="totalunit">Baht/kWh</span>
                    </div>
                    <div className="container">
                        <label>FT Charge Rate</label>
                        <span className='font-sarabun' id="data-monthly-ref-ft2">{reportdata.Refference?.Factor_FT}</span>
                        <span className="totalunit">Baht/kWh</span>
                    </div>
                    {
                        reportdata.Refference?.SolarType !== "Rooftop + Floating" ?
                            <div className="container">
                                <label>Discount of Contract =</label>
                                <span className='font-sarabun' id="data-monthly-ref-saving">{reportdata.Refference?.Contract_Discount}</span>
                                <span className="totalunit">%</span>
                            </div>
                            :
                            <>
                                <div className="container">
                                    <label>Discount of Rooftop =</label>
                                    <span className='font-sarabun' id="data-monthly-ref-saving">{reportdata.Refference?.Contract_Discount1}</span>
                                    <span className="totalunit">%</span>
                                </div>
                                <div className="container">
                                    <label>Discount of Floating =</label>
                                    <span className='font-sarabun' id="data-monthly-ref-saving">{reportdata.Refference?.Contract_Discount2}</span>
                                    <span className="totalunit">%</span>
                                </div>
                            </>
                    }
                </div>

                <div className="doc-remark">
                    <label className="generate-remark1" id="generate-daily-print1">Printed Date : {reportdata.Header?.PrintDate}</label>
                    <label className="generate-remark2">* This reports have been generated by CPF solar monitoring system local web
                        application. *</label>
                </div>
            </div>

            <div className="page-horizontal rp-monthly mt-2">
                <div className="document-header">
                    <div className="document-logo-left">
                        <img src="/images/ReportLogoleft.bmp" className="logo" style={{ opacity: "1" }} alt='logo-left3' />
                    </div>
                    <div className="document-logo-right">
                        {/* <img src="/images/ReportLogoright.bmp" className="logo" style={{ opacity: "1" }} alt='logo-right3' /> */}
                        <div className="company-box">
                            SHINING SPV 1 CO., LTD.
                        </div>
                    </div>

                    <label className="document-type">Monthly Report</label>
                    <label className="document-date" id="data-monthly-header-reportdate3">{reportdata.Header?.ReportDate}</label>
                    <label className="document-sitelocation" id="data-monthly-header-sitename3">{reportdata.Header?.SiteName}</label>
                    <label className="document-pages">Pages 3/3</label>

                    <div className="document-capacity">
                        <div className="container">
                            <label>Capacity</label>
                            <span className='font-sarabun' id="data-monthly-header-capacity3">{reportdata.Header?.Capacity}</span>
                            <span className="totalunit">kWp</span>
                        </div>
                    </div>

                    <div className="document-area">
                        <div className="container">
                            <label>Area</label>
                            <span className='font-sarabun' id="data-monthly-header-area3">{reportdata.Header?.Area}</span>
                            <span className="totalunit">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                <div className="document-info">
                    <div className="document-info1">
                        <div className="container">
                            <label>Energy from Solar {reportdata.Header?.SolarType}</label>
                            <span className='font-sarabun' id="data-monthly-info-energysolar3">{reportdata.Info?.EnergySolar}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, On-Peak</label>
                            <span className='font-sarabun ' id="data-monthly-info-energysolar-onpeak3">{reportdata.Info?.EnergySolar_OnPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, Off-Peak</label>
                            <span className='font-sarabun ' id="data-monthly-info-energysolar-offpeak3">{reportdata.Info?.EnergySolar_OffPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                    </div>
                    <div className="document-info2">
                        <div className="container">
                            <label>Energy not Supply (ENS)</label>
                            <span className='font-sarabun' id="data-monthly-info-ens3" >{reportdata.Info?.ENS}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>CO<sub>2</sub> Reduction</label>
                            <span className='font-sarabun' id="data-monthly-info-co23">{reportdata.Info?.CO2}</span>
                            <span className="totalunit">kgCO<sub>2</sub></span>
                        </div>
                    </div>
                    <div className="document-info3">
                        <div className="container">
                            <label>PR</label>
                            <span id="data-monthly-info-prens3" className={'font-sarabun ' + getErrColor(reportdata.FlagPR)}>{getErrText(reportdata.FlagPR, reportdata.Info?.PR_ENS)}</span>
                            <span className="totalunit">%</span>
                        </div>
                        <div className="container">
                            <label>OR</label>
                            <span id="data-monthly-info-or3" className={'font-sarabun ' + getErrColor(reportdata.FlagOR)}>{reportdata.Info?.ORX_ENS}</span>
                            <span className="totalunit">%</span>
                        </div>
                    </div>

                    <div className="document-info4">
                        <div className="container">
                            <label>Irradiance</label>
                            <span className='font-sarabun' id="data-monthly-info-irr3" >{reportdata.Info?.IRR}</span>
                            <span className="totalunit">Wh/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Irradiance (max)</label>
                            <span className='font-sarabun' id="data-monthly-info-irrmax3" >{reportdata.Info?.IRRMax}</span>
                            <span className="totalunit">W/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Module Temp (max)</label>
                            <span className='font-sarabun' id="data-monthly-info-tempmax3" >{reportdata.Info?.ModuleTempMax}</span>
                            <span className="totalunit">°C</span>
                        </div>
                    </div>
                </div>

                <div className="chart-monthly-wrapper">
                    <div className="chx" id="trend-monthly" style={{ height: "545px", width: "100%" }}>
                        <CanvasJSReact_ReportMonthly
                            info={reportdata.Header}
                            xlabel={reportchart.XLabel}
                            solorpower={reportchart.EnergyAC}
                            estimatepower={reportchart.EnergyEST}
                            ens={reportchart.ENS}
                            error={reportchart.errorx}
                        ></CanvasJSReact_ReportMonthly>
                    </div>
                </div>

                <div className="doc-remark">
                    <label className="generate-remark1" id="generate-daily-print1">Printed Date : {reportdata.Header?.PrintDate}</label>
                    <label className="generate-remark2">* This reports have been generated by CPF solar monitoring system local web
                        application. *</label>
                </div>
            </div>
        </div>
    )
}
export default SiteReportMonthly